module.exports = __webpack_public_path__ + "img/add-icon.4675acf3.svg";